import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';

import { UPermissionsName } from '../../core/permissions';

export const useAccess = (perm: UPermissionsName): [boolean] => {
  const userProfileStore = useUserProfileStore();
  const hasAccees = userProfileStore.perms.has(perm);

  return [hasAccees];
};
